import { FloatingLabel, Form, InputGroup } from "react-bootstrap"
import { FieldValues, useController } from "react-hook-form"
import { ManagedPropsWithLabel } from "./type"
import React, { ComponentProps, ReactNode, useId } from "react"

type Props<TFieldValues extends FieldValues, TContext = unknown, TTransformedValues = TFieldValues> = ManagedPropsWithLabel<TFieldValues, TContext, TTransformedValues> &
  // 問題なさそうなものを随時追加していく
  Pick<ComponentProps<typeof Form.Control>, "type"> & {
  inputGroupAfter?: ReactNode
}

export function ManagedFloatingInput<TFieldValues extends FieldValues, TContext = unknown, TTransformedValues = TFieldValues>({ control, name, label, helper, required, inputGroupAfter, ...formControlProps }: Props<TFieldValues, TContext, TTransformedValues>) {
  const id = useId()
  const { field, fieldState } = useController({ name, control })

  return (
    <>
      <Form.Group controlId={id}>
        <InputGroup>
          <FloatingLabel
            controlId={id}
            label={label}
          >
            <Form.Control {...formControlProps} {...field} />
          </FloatingLabel>
          {inputGroupAfter}
        </InputGroup>
        {fieldState.error ? <Form.Text className="text-danger">{fieldState.error.message}</Form.Text> : helper != null ? <Form.Text className="text-muted">{helper}</Form.Text> : null}
      </Form.Group>
    </>
  )
}
